import React from 'react';
import { Icon } from '../core/Icon.jsx';
import { IconButton } from '../core/IconButton.jsx';

const ICONS = { signal: 'zap', data: 'bar-chart-2', danger: 'alert-triangle', neutral: 'info' };

export function Alert({ tone = 'neutral', icon, title, actions, onDismiss, children, className = '', ...rest }) {
  return (
    <div className={['sp-alert', 'sp-alert--' + tone, className].filter(Boolean).join(' ')} role="status" {...rest}>
      <span className="sp-alert__icon"><Icon name={icon || ICONS[tone]} size={16} /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && <div className="sp-alert__title">{title}</div>}
        {children && <div className="sp-alert__body">{children}</div>}
        {actions && <div style={{ display: 'flex', gap: 'var(--space-2)', marginTop: 'var(--space-3)' }}>{actions}</div>}
      </div>
      {onDismiss && <IconButton icon="x" label="Dismiss" size="sm" onClick={onDismiss} />}
    </div>
  );
}
